<template>
    <div class="col-xl-3 xl-40">
        <div class="md-sidebar job-sidebar"><a class="btn btn-primary md-sidebar-toggle" href="javascript:void(0)"
                @click="collapseFilter()">learning
                filter</a>
            <div class="md-sidebar-aside job-left-aside custom-scrollbar" :class="filtered ? 'open' : ''">
                <div class="default-according style-1  job-accordion" id="accordionoc">
                    <div class="row">
                        <learningtab />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import learningtab from "./learningTab.vue"
import {
    mapGetters
} from 'vuex';
export default {
    components: {
        learningtab
    },
    computed: {
        ...mapGetters({
            specialcourses: 'courses/specialcourses',
            normalcourses: 'courses/normalcourses'
        })
    },
    data() {
        return {
            filtered: false,
        }
    },
    methods: {
        getImgUrl(filename) {
            var images = require.context('../../../assets/images/faq/', false, /\.jpg$/);
            return images('./' + filename);
        },
        collapseFilter() {
            this.filtered = !this.filtered;
        },
    }
}
</script>
